import bankList from '../constants/bank-list'

import { TSelectOption } from '@/components/shared/searchable-select'

type TPayoutInfo = {
  id: string
  type: string
  provider: string
  accountNumber: string
  accountName: string
}

type TBank = {
  src: string
  alt: string
  name: string
  isShow: boolean
  xenditChannelCode: string | null
}

type TWithdrawMethodWhitelist = {
  name: string
  type: string
}

export const whitelistPayoutFilter = ({
  payoutInfo,
  whitelist,
}: {
  payoutInfo?: TPayoutInfo[]
  whitelist?: TWithdrawMethodWhitelist[]
}): TPayoutInfo[] => {
  if (!payoutInfo) return []

  if (!whitelist || whitelist.length === 0) {
    return payoutInfo
  }

  return payoutInfo.filter(
    (info) =>
      info?.provider &&
      info?.type &&
      whitelist.some(
        (method) =>
          method?.name?.toLowerCase() === info.provider.toLowerCase() && method?.type === info.type,
      ),
  )
}

export const hasBankType = (whitelist?: TWithdrawMethodWhitelist[]): boolean => {
  if (!whitelist || whitelist.length === 0) return true

  return whitelist.some((method) => method.type === 'BANK')
}

export const hasEWalletType = (whitelist?: TWithdrawMethodWhitelist[]): boolean => {
  if (!whitelist || whitelist.length === 0) return true

  return whitelist.some((method) => method.type === 'EWALLET')
}

export const filterBankListByWhitelist = ({
  bankList,
  whitelist,
}: {
  bankList: Record<string, TBank>
  whitelist?: TWithdrawMethodWhitelist[]
}): Record<string, TBank> => {
  if (!whitelist || whitelist.length === 0) return bankList
  const allowedNames = new Set(whitelist.map((method) => method.name.toLowerCase()))

  return Object.fromEntries(
    Object.entries(bankList).filter(([, bank]) => allowedNames.has(bank.alt.toLowerCase())),
  )
}

export const mappedBankList = ({
  list = bankList,
}: {
  list?: Record<string, TBank>
}): TSelectOption[] => {
  return Object.keys(list)
    .filter((key: keyof typeof list) => list[key].alt !== 'unknown' && list[key].isShow)
    .map((key: keyof typeof list) => ({
      label: list[key].name,
      value: list[key].alt,
      imgSrc: list[key].src,
    }))
}

export const getBankOptions = ({
  whitelist,
  partner,
}: {
  whitelist?: TWithdrawMethodWhitelist[]
  partner?: boolean
}) => {
  if (!whitelist || whitelist.length === 0 || !partner) return mappedBankList({})
  return mappedBankList({
    list: filterBankListByWhitelist({
      bankList,
      whitelist,
    }),
  })
}

export const getPayoutInfo = ({
  payoutInfo,
  whitelist,
  partner,
}: {
  payoutInfo?: TPayoutInfo[]
  whitelist?: TWithdrawMethodWhitelist[]
  partner?: boolean
}) => {
  if (!whitelist || whitelist.length === 0 || !partner) return payoutInfo
  return whitelistPayoutFilter({ payoutInfo, whitelist })
}
